import { adminHttpClient } from "../commons/adminHttpClient";

const getLiveBroadcastAuditReportExcel = (id: string): Promise<any> => {
  return adminHttpClient.get(`/LiveBroadcastAudits/View/GenerateExcel/${id}`);
};

export default getLiveBroadcastAuditReportExcel;